import React, { useState, useEffect } from 'react';
import useStateRef from 'react-usestateref';
import MyAccountCommonize from './MyAccountCommonize';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction';
import { useSelector, useDispatch } from 'react-redux';
import Loader from '../Loader/Loader';
function MyProfile({ containerObject, templateName, contentId, dataZone }) {
    const [pwd, setPwd] = useState('');
    const [isRevealPwd, setIsRevealPwd] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const [profileError, setProfileError, profileErrorRef] = useStateRef('')
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();
    const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
    const [firstName, setFirstName, firstNameRef] = useStateRef()
    const [lastName, setLastName, lastNameRef] = useStateRef()
    const [email, setEmail, emailRef] = useStateRef()
    const [userProfileId, setUserProfileId, userProfileIdRef] = useStateRef()
    const [generatedPassword, setgeneratedPassword, generatedPasswordRef] = useStateRef()
    const loaderStatus = useSelector(state => state.getLoaderStatus.loaderStatus)
    const handleMouseEnter = () => {
        setShowTooltip(true);
    };
    useEffect(() => {
        if (loaderStatus == true) {
            console.log("log in myprofile page loader true");
        } else {
            console.log("log in myprofile page loader false");
            var searchParam = window.location.search
            const params = new URLSearchParams(searchParam);
            var profileId = params.get('id')
            if (profileId) {
                setIsLoading(true)
                fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/profile-details/${profileId}`, {
                    method: 'GET'
                }).then(res => res.json())
                    .then(res => {
                        if (res.result === "success") {
                            setIsLoading(false)
                            setgeneratedPassword(res.response && res.response.generatedPassword)
                            if (res.response && res.response.generatedPassword) {
                                setUserProfileId(profileId)
                                setFirstName(res.response && res.response.firstName)
                                setLastName(res.response && res.response.lastName)
                                setEmail(res.response && res.response.email)
                            } else {
                                history.push("/")
                            }
                        }
                    })
            }

            var id = window.location.search
            var splitedIdUri = id.split("?")
            if (profileDetails) {
                if (splitedIdUri[1] == "success=true") {
                    document.getElementById("profile-success").classList.remove("d-none");
                    document.getElementById("profile-success").classList.add("d-block");
                }
            }
        }

    }, [])

    // useEffect(() => {
    //     var id = window.location.search
    //     var splitedIdUri = id.split("?")
    //     if (profileDetails) {
    //         if (splitedIdUri[1] == "success=true") {
    //             document.getElementById("profile-success").classList.remove("d-none");
    //             document.getElementById("profile-success").classList.add("d-block");
    //         }
    //     }
    // }, [])
    const handleMouseLeave = () => {
        setShowTooltip(false);
    };
    function handlePrintPage() {
        window.print()
    }
    const removeFormError = () => {
        var inputFields = ['firstName', 'lastName', 'password', 'email'];
        inputFields.map((fieldName, index) => (
            document.getElementById("profile_" + fieldName).classList.remove("form-error")
        ))
    }
    const handleUpdateProfile = (event) => {
        event.preventDefault();
        setIsLoading(true)
        removeFormError();
        var sId = new FormData(document.getElementById('update'))

        var firstName = sId.get("firstName")
        var lastName = sId.get("lastName")
        var password = sId.get("password")
        var email = sId.get("email")
        const inputMap = {
            firstName: firstName,
            lastName: lastName,
            password: password,
            email: email,
            profileId: userProfileIdRef.current ? userProfileIdRef.current : ""
        }
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/update-profile`, {
            credentials: "include",
            method: "POST",
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(inputMap)
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    setIsLoading(false)
                    setFirstName(firstName)
                    setLastName(lastName)
                    setEmail(email)
                    dispatch(updateProfileDetailsAction(true, "login"))
                    history.push("/account/profile?success=true")

                } else {
                    setIsLoading(false)
                    const error = res._ERROR_MESSAGE_;
                    setProfileError(res._ERROR_MESSAGE_.errors)
                    // setErrorMessage(error);
                    document.getElementById("profile-error").classList.remove("d-none");
                    document.getElementById("profile-error").classList.add("d-block");
                    const err = res._ERROR_MESSAGE_.properties;
                    {
                        Array.isArray(res._ERROR_MESSAGE_.properties) && res._ERROR_MESSAGE_.properties.length > 0 && (
                            res._ERROR_MESSAGE_.properties.map((message, index) => (
                                document.getElementById("profile_" + message).classList.add("form-error")
                            ))
                        )
                    }
                }
            })
    }
    const handleOnChangeField = (event, Id) => {
        if (profileDetails && profileDetails.transient) {
            // 
        }
        else {
            if (Id == "profile_firstName") {
                setFirstName(event.currentTarget.value)
            } else if (Id == "profile_lastName") {
                setLastName(event.currentTarget.value)
            } else if (Id == "profile_email") {
                setEmail(event.currentTarget.value)
            }
        }
    }
    return (
        <>
            {isLoading && <Loader />}
            <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-my-profile`}>
                {!generatedPasswordRef.current &&
                    <div className="row align-items-center mx-1 justify-content-between c-breadcrumb-custom">
                        <div className="col-md-11">
                            <nav className="c-breadcrumb" aria-label="breadcrumb">
                                <ol className="breadcrumb">

                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/account/landing">My Account</Link></li>
                                    <li className="breadcrumb-item active"><Link to="#">My Profile</Link></li>

                                </ol>
                            </nav>
                        </div>

                        <div className="col-12 col-md-1 d-none d-lg-block">
                            <button className="btn btn-light c-print-btn text-end" type="button" onClick={handlePrintPage}>
                                <i className="fas fa-print" ></i>Print
                            </button>
                        </div>

                    </div>
                }
                <div className="row page-min-height gx-0 c-shopping-list-item-padding">
                    {!generatedPasswordRef.current && <MyAccountCommonize />}
                    {(!generatedPasswordRef.current && !userProfileIdRef.current) || (generatedPasswordRef.current && userProfileIdRef.current) ?
                        <div id="content" className="col-lg-9 c-shopping-list-item-col c-my-profile-details">
                            <div id="profile-error" className="col-lg-12 alert alert-danger form-error-messages" role="alert" wfd-invisible="true">
                                {Array.isArray(profileErrorRef.current) && profileErrorRef.current.length > 0 && (
                                    profileErrorRef.current.map((message, index) => (
                                        <p key={index}>{message}</p>
                                    ))
                                )}
                            </div>
                            <div id='profile-success' className="alert alert-success" role="alert">
                                <p>
                                    Your changes have been successfully saved.
                                </p>
                            </div>
                            <div className="row my-3 d-none d-md-block">
                                <div className="col-6 col-md-6">
                                    <h1 className="right-panel-heading">My Profile</h1>
                                </div>
                            </div>
                            <h1 className="right-panel-heading d-block d-md-none p-0">My Profile</h1>

                            <div className='row'>
                                <div className='col-md-12 c-my-profile-list'>
                                    <p>If you need to make changes to your profile information, adjust as necessary and click <strong>Update Profile</strong> to save your changes.
                                    </p>
                                    <form method="post" autoComplete='off' action="/account/profile" id="update" onSubmit={handleUpdateProfile} className="c-account-page g-3" data-hs-cf-bound="true">
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <label for="firstName" className="form-label">First Name</label>
                                                <input maxlength="19" name="firstName" id="profile_firstName" type="text" readOnly={userProfileIdRef.current ? "readonly" : ""} className="form-control" defaultValue={firstNameRef.current ? firstNameRef.current : profileDetails && profileDetails.firstName}
                                                    onChange={(event) => handleOnChangeField(event, "profile_firstName")} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <label for="lastName" className="form-label">Last Name</label>
                                                <input maxlength="19" name="lastName" id="profile_lastName" type="text" readOnly={userProfileIdRef.current ? "readonly" : ""} className="form-control" defaultValue={lastNameRef.current ? lastNameRef.current : profileDetails && profileDetails.lastName}
                                                    onChange={(event) => handleOnChangeField(event, "profile_lastName")} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <label for="email" className="form-label">Email</label>
                                                <input autoComplete="new-email" maxlength="256" name="email" id="profile_email" type="text" readOnly={userProfileIdRef.current ? "readonly" : ""} className="form-control" defaultValue={emailRef.current ? emailRef.current : profileDetails && profileDetails.email}
                                                    onChange={(event) => handleOnChangeField(event, "profile_email")} />

                                            </div>
                                        </div>
                                        <div className="row">

                                            <div className="col-md-4 mb-4">

                                                <label for="password" className="form-label">New Password *</label>
                                                <div className="c-input-tooltip c-input-password">
                                                    <input autoComplete="new-password" name="password" id="profile_password" type={isRevealPwd ? "text" : "password"} className="form-control" defaultValue={pwd} onChange={e => setPwd(e.target.value)} />
                                                    <Link className="c-register-passShow" style={{ textDecoration: 'none', position: 'absolute' }} id="show-password" onClick={() => setIsRevealPwd(prevState => !prevState)}>
                                                        {isRevealPwd ? 'HIDE' : 'SHOW'}
                                                    </Link>
                                                    <span className="c-tooltip" onMouseEnter={handleMouseEnter}
                                                        onMouseLeave={handleMouseLeave}>
                                                        <i className="fa fa-question-circle"></i>
                                                        {showTooltip && (
                                                            <div
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '-68px',
                                                                    left: '144px',
                                                                    backgroundColor: '#fbf3bf',
                                                                    color: '#333',
                                                                    padding: '0.875rem',
                                                                    zIndex: '1',
                                                                    width: '200px',
                                                                    fontSize: '0.75rem',
                                                                    border: "0.063rem solid #ccc",
                                                                    boxShadow: "0 0 0.625rem #ccc",
                                                                    lineHeight: "1.125rem",
                                                                    borderRadius: "0.313rem",
                                                                    textAlign: "left"
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '65px',
                                                                        left: '50%',
                                                                        marginLeft: '-13px',
                                                                        width: '0',
                                                                        height: '0',
                                                                        borderLeft: '5px solid transparent',
                                                                        borderRight: '5px solid transparent',
                                                                        borderTop: '7px solid #333',
                                                                    }}
                                                                ></div>
                                                                Passwords must be at least 6 characters long.
                                                            </div>
                                                        )}
                                                    </span>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="row g-3 mb-3">
                                            <div className="col-md-4 d-grid">
                                                <button type="submit" className="btn btn-primary block">Update Profile</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        : ""}
                </div>
            </div>
        </>
    );
}

export default MyProfile;
